export const appPauseIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="4" width="6" height="16" rx="1" fill="white"/><rect x="13" y="4" width="6" height="16" rx="1" fill="white"/></svg>`,
    name: 'pause'
};